<!-- 二级筛选 -->
<template>
    <div class="filter-product-container" ref="activity_scroll" @scroll="activityScroll">
        <!-- 顶部搜索组件 -->
        <roof-search @secondCategoryChange="secondCategoryChange"></roof-search>
        <!-- 商城 -->
        <product-content :showFilrtate="showFiltrate" :productList="productListData" @attrFilterData="attrFilterData" ref="product_content"></product-content>
    </div>
</template>

<script>
import roofSearch from '@/components/roof-search'
import productContent from './components/product-content'
import { getProductList, categoryInfo, getAllCategory } from '@/api/product'
import { getCookie, setCookie } from '@/libs/util'
import { wxShare } from '@/libs/wxjssdk'
import Qs from 'qs'
export default {
    components: {
        roofSearch,
        productContent
    },
    data () {
        return {
            title: '',
            params: {
                category_id: '', // 二级分类id
                // title: '',
                parent_category_id: '' // 一级分类id
            },
            page: 1, // 当前页码
            pageSize: 10, // 一页显示10个
            last_page: 1, // 最后一页的页码
            productList: [
                {
                    title: '',
                    product: []
                }
            ],
            productListData: [],
            showFiltrate: true,
            shareDescText: '',
            shareTitle: ''
        }
    },
    created () {
    },
    mounted () {
        this.getCookieParams()
    },
    methods: {
        sharePage () {
            const params = {
                title: `${this.shareTitle}`, // 分享标题
                desc: this.shareDescText, // 分享描述
                link: `${window.location.href.split('?')[0]}#/secondProduct?${Qs.stringify(this.params)}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            console.log(params)
            wxShare(params)
        },
        // 上拉触底
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 150 // 距离底部距离
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.page < this.last_page) {
                    this.page++
                    this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        duration: 0
                    })
                    this.getProductListPort()
                }
            }
        },
        // 读取cookie
        getCookieParams (val, type) {
            var params = getCookie('second_category')
            console.log('读取cookie', JSON.parse(params))
            if (type === 'select') {
                if (params) {
                    // console.log(this.$route.query.parent_category_id)
                    this.params = JSON.parse(params)
                } else {
                    this.params = this.$route.query || {}
                }
            } else {
                if (this.$route.query.parent_category_id) {
                    this.params = this.$route.query || {}
                    setCookie('second_category', this.params)
                } else {
                    if (params) {
                        // console.log(this.$route.query.parent_category_id)
                        this.params = JSON.parse(params)
                    } else {
                        this.params = this.$route.query || {}
                    }
                }
            }

            var paramsKey = Object.keys(this.params)
            // console.log(paramsKey)
            if (paramsKey.indexOf('category_id') === -1 || val) {
                this.showFiltrate = true
                // console.log('打印啊啊啊啊', this.params.parent_category_id)
                // 获取attr数据
                this.$nextTick(() => {
                    this.$refs.product_content.getConditionPort({
                        category_id: this.params.parent_category_id
                    })
                })
            } else {
                this.showFiltrate = false
            }
            this.productList[0].product = []
            this.page = 1
            // var href = window.location.href.split('?')[0] + '?' + Qs.stringify(this.params)
            // window.location.href = href
            this.$router.replace({
                name: 'secondProduct',
                query: this.params
            })
            console.log('打印路由', this.$route)
            this.getProductListPort()
            this.getAllCategoryPort()
        },
        // 单击了分类(接受了一个参数，如果是1一没有子元素 和 二级单击的是全部，传的是true)
        secondCategoryChange (val) {
            // console.log('单击了一级分类或者全部', val)
            this.getCookieParams(val, 'select')
        },
        // attr_id 改变( button单击确定按钮 )，重新获取数据
        attrFilterData (attrId) {
            // console.log(attrId, 666667777)
            var params = {
                attr_id: attrId,
                parent_category_id: this.params.parent_category_id
            }
            this.page = 1
            this.productList[0].product = []
            this.params = params
            this.getProductListPort()
            this.getAllCategoryPort()
        },
        /** 网络请求 **/
        // 根据一级类别和二级类别获取数据
        getProductListPort () {
            var params = {
                ...this.params,
                page: this.page,
                size: this.pageSize
            }
            // console.log('paramsparams', params)
            getProductList(params).then((res) => {
                if (res.errCode === 0) {
                    var data = res.data
                    this.last_page = data.last_page
                    // console.log(data.data)
                    var productList = this.productList[0].product
                    productList.push(...data.data)
                    this.productListData = JSON.parse(
                        JSON.stringify(this.productList)
                    )
                    // console.log('打印新的数据', productList)
                    this.getCategoryInfo(this.params.parent_category_id)
                }
            })
        },

        // 获取类别详情
        getCategoryInfo (categoryId) {
            var params = {
                category_id: categoryId
            }
            categoryInfo(params).then((res) => {
                if (res.errCode === 0) {
                    var data = res.data
                    // console.log('获取类别详情', data)
                    this.title = data.title || ''
                    this.productList[0].title = data.title || ''
                    this.productListData[0].title = data.title || ''
                }
            })
        },

        //  获取所有分类
        getAllCategoryPort () {
            getAllCategory().then((res) => {
                this.shareTitle = ''
                this.shareDescText = ''
                const firstType = res.filter((item) => {
                    if (Number(item.id) === Number(this.params.parent_category_id)) {
                        this.shareTitle = item.title
                        return item
                    }
                })

                if (!this.params.category_id) {
                    document.title = `${this.shareTitle}`
                    // 如果没有二级ID
                    if (firstType[0].children) {
                        firstType[0].children.forEach((item, index) => {
                            if (index === firstType[0].children.length - 1) {
                                this.shareDescText += `${item.title}`
                            } else {
                                this.shareDescText += `${item.title}、`
                            }
                        })
                    }
                } else {
                    // console.log(firstType)
                    firstType[0].children.forEach((item, index) => {
                        if (Number(item.id) === Number(this.params.category_id)) {
                            this.shareDescText = `${this.shareTitle} - ${item.title}`
                        }
                    })
                    document.title = `${this.shareDescText}`
                }
                this.shareDescText.substring(0, this.shareDescText.length - 1)
                this.sharePage()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-product-container {
    background: #eeebf4;
    /*display: flex;*/
    /*flex-direction: column;*/
    height: 100vh;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
}
</style>
